module.exports = __webpack_public_path__ + "img/13_K_hearts.776650de.png";